export class SuspendWorkIssueNotificationSlider {
  text = "Team Work Issue Notifications - Enabled";
  enabled = true;
}
